import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, role }) => {
  const token = localStorage.getItem("accessToken"); // ✅ consistent key
  const user = JSON.parse(localStorage.getItem("user"));

  // अगर login ही नहीं है
  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  // अगर role mismatch है
  if (role && user.role !== role) {
    return <Navigate to="/" replace />;
  }

  // ✅ सब ठीक है
  return children;
};

export default ProtectedRoute;